module.exports = __webpack_public_path__ + "img/04.7c021b9d.png";